const items = [
  "Foso Universal",
  "Campeonato de Europa FEDECAT",
  "Trap 5",
  "Foso Olímpico",
  "Premiados",
  "Campeonato del Mundo FEDECAT",
  "Crónicas",
  "Calendario 2026",
];

export function EditorialMarquee() {
  return (
    <div className="overflow-hidden border-y border-clay/20 bg-clay py-4 text-charcoal" data-testid="editorial-marquee">
      <div className="marquee-track flex w-max items-center gap-10">
        {[...items, ...items, ...items].map((item, index) => (
          <span key={`${item}-${index}`} className="flex items-center gap-10 whitespace-nowrap font-display text-3xl uppercase tracking-wide">
            {item}
            <span className="h-2 w-2 rotate-45 bg-charcoal" />
          </span>
        ))}
      </div>
    </div>
  );
}
